const TextError = (props) => {
    return (
        <div className="field-error">
            {props.children}
        </div>
    )
}

export default TextError
